
export const jarvisPrimeRmsConstants = {
    PRIME_RMS_API: "prime/portfolio/rms",
    PRIME_RMS_SAGA: "PRIME_RMS_SAGA",
    PRIME_RMS_REQUEST: "PRIME_RMS_REQUEST",
    PRIME_RMS_RESPONSE: "PRIME_RMS_RESPONSE",
    PRIME_RESET_RMS_DATA: "PRIME_RESET_RMS_DATA"
}